"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Signature = void 0;
var bitcoinjs_lib_1 = require("bitcoinjs-lib");
var Signature = /** @class */ (function () {
    function Signature(_signature) {
        this._signature = _signature;
    }
    Signature.deserialize = function (signatureBuffer) {
        var buffer = Buffer.alloc(65);
        signatureBuffer.copy(buffer, 1);
        buffer.writeInt8(31, 0);
        var signature = bitcoinjs_lib_1.ECSignature.parseCompact(buffer).signature;
        return new Signature(signature);
    };
    Signature.fromString = function (string) {
        return Signature.deserialize(Buffer.from(string, 'hex'));
    };
    Signature.prototype.serialize = function () {
        var signatureBuffer = Buffer.alloc(64);
        this._signature.toCompact(0, true).copy(signatureBuffer, 0, 1);
        return signatureBuffer;
    };
    Signature.prototype.toString = function () {
        return this.serialize().toString('hex');
    };
    return Signature;
}());
exports.Signature = Signature;
//# sourceMappingURL=Signature.js.map